import script from "./ProfilePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfilePage.vue?vue&type=script&setup=true&lang=js"

import "./ProfilePage.vue?vue&type=style&index=0&id=55270545&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55270545"]])

export default __exports__